import styled from 'styled-components';

import { spaceMixin, token } from '@zillow/constellation';

type Args = {
  listingToursCount: number;
};

export const StyledContainer = styled.div<Args>`
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${token('colors.gray300')};
  color: ${token('colors.textDark')};
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  min-height: 240px;
  max-height: 311px;
  max-width: ${({ listingToursCount }) => (listingToursCount === 0 ? '100%' : '270px')};
  padding: ${spaceMixin('sm')};
  text-align: center;
`;
